<template>
  <component v-if="reviews.total > 0" :is="conditionalElement" v-bind="conditionalProps('#ReviewsWidget')" class="ReviewStars">
    <div class="ReviewStars__Wrapper" :hidden="reviews.total > 0">
      <div class="ReviewStars__Bottom">
        <Icon :icon="'star'" v-for="i in stars" :key="i" />
      </div>
      <div class="ReviewStars__Top" :style="{ clip: 'rect(0px,' + starTopWidth + 'px, 50px, 0px)' }">
        <Icon :icon="'star'" v-for="i in stars" :key="i" />
      </div>
      <p class="ReviewStars__Total p5">({{ total }})</p>
    </div>
  </component>
  <span v-if="location == 'quick-view'" class="placeholder"></span>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import Icon from './Icon.vue';

const props = defineProps({
  product: String,
  location: { type: String, required: false },
});

const key = 'MdtpPOdzecvdDWwA3pFvhLyB6ab4osWf5p8TQHpj';

// Yotpo API Docs
// https://apidocs.yotpo.com/reference/retrieve-reviews-for-a-product
const endpoint = `https://api-cdn.yotpo.com/v1/widget/${key}/products/${props.product}/reviews.json`;

const stars = ref(5);
const reviews = ref(false);
const loaded = ref(false);

const conditionalProps = computed(() => {
  return (url) => {
    const isLink = conditionalElement.value === 'a';
    if (!isLink) return {};
    return {
      href: url,
    };
  };
});

const conditionalElement = computed(() => {
  return props.location == 'quick-view' || props.location == 'product-card' ? 'div' : 'a';
});

const starTopWidth = computed(() => {
  const rating = reviews.value.average;
  const percentage = rating * 10;
  const width = percentage + 26;
  return width;
});

const total = computed(() => {
  if (!!reviews.value) return reviews.value?.total.toLocaleString() || '';
  else return '';
});

function format(context) {
  const data = context || false;
  if (!data) return;

  const total = parseInt(data.total_review);
  const average = parseFloat(data.average_score);

  return {
    average,
    total,
  };
}

async function fetchReviews() {
  try {
    const reviewData = await fetch(endpoint)
      .then((res) => res.json())
      .then((json) => json.response.bottomline);

    reviews.value = format(reviewData);
    return;
  } catch (err) {
    console.log(err);
  }
}

onMounted(() => {
  fetchReviews();
});
</script>
